import { NgIf } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BoondockFacade } from '@curbnturf/boondock-listing';
import { Boondock, CARETAKER_TEDDY_ID } from '@curbnturf/entities';
import { IonicModule, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { RatingBoondockActivitiesComponent } from '../rating-boondock-activities/rating-boondock-activities.component';
import { RatingBoondockAmenitiesComponent } from '../rating-boondock-amenities/rating-boondock-amenities.component';
import { RatingBoondockCaretakerComponent } from '../rating-boondock-caretaker/rating-boondock-caretaker.component';
import { RatingBoondockCompleteComponent } from '../rating-boondock-complete/rating-boondock-complete.component';
import { RatingBoondockConditionsComponent } from '../rating-boondock-conditions/rating-boondock-conditions.component';
import { RatingBoondockDescriptionComponent } from '../rating-boondock-description/rating-boondock-description.component';
import { RatingBoondockPublicReviewComponent } from '../rating-boondock-public-review/rating-boondock-public-review.component';
import { RatingBoondockSectionsComponent } from '../rating-boondock-sections/rating-boondock-sections.component';
import { RatingBoondockStartComponent } from '../rating-boondock-start/rating-boondock-start.component';
import { RatingBoondockTerrainComponent } from '../rating-boondock-terrain/rating-boondock-terrain.component';

@Component({
  selector: 'curbnturf-rating-boondock-modal-controller',
  templateUrl: './rating-boondock-modal-controller.component.html',
  styleUrls: ['./rating-boondock-modal-controller.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgIf,
    RatingBoondockActivitiesComponent,
    RatingBoondockAmenitiesComponent,
    RatingBoondockCaretakerComponent,
    RatingBoondockCompleteComponent,
    RatingBoondockConditionsComponent,
    RatingBoondockDescriptionComponent,
    RatingBoondockPublicReviewComponent,
    RatingBoondockSectionsComponent,
    RatingBoondockStartComponent,
    RatingBoondockTerrainComponent,
  ],
})
export class RatingBoondockModalControllerComponent implements OnChanges, OnInit {
  @ViewChild('modalWrapper') modalWrapper: ElementRef;

  @Input() boondockId?: number;

  beginScreen: boolean = true;
  caretakerScreen: boolean = false;
  sectionsScreen: boolean = false;
  reviewScreen: boolean = false;
  activitiesScreen: boolean = false;
  amenitiesScreen: boolean = false;
  terrainScreen: boolean = false;
  conditionsScreen: boolean = false;
  descriptionScreen: boolean = false;
  completeScreen: boolean = false;

  get currentStep() {
    if (this.beginScreen) {
      return 'start';
    } else if (this.caretakerScreen) {
      return 'caretaker';
    } else if (this.sectionsScreen) {
      return 'sections';
    } else if (this.reviewScreen) {
      return 'review';
    } else if (this.activitiesScreen) {
      return 'activities';
    } else if (this.amenitiesScreen) {
      return 'amenities';
    } else if (this.terrainScreen) {
      return 'terrain';
    } else if (this.conditionsScreen) {
      return 'conditions';
    } else if (this.descriptionScreen) {
      return 'description';
    } else if (this.completeScreen) {
      return 'complete';
    } else {
      return 'start';
    }
  }

  private subscriptions: Subscription[] = [];
  private boondock: Boondock;

  constructor(
    private modalController: ModalController,
    private boondockFacade: BoondockFacade,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.boondockFacade.selected$.subscribe((boondock) => {
        if (boondock) {
          this.boondock = boondock;
        }
      }),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.boondockId.currentValue) {
      this.boondockFacade.select(this.boondockId);
    }
  }

  async onSkipSection(section: string) {
    switch (section) {
      case 'caretaker':
        this.caretakerScreen = false;
        this.sectionsScreen = true;
        break;
      case 'activities':
        this.activitiesScreen = false;
        this.amenitiesScreen = true;
        break;
      case 'amenities':
        this.amenitiesScreen = false;
        this.terrainScreen = true;
        break;
      case 'terrain':
        this.terrainScreen = false;
        this.conditionsScreen = true;
        break;
      case 'conditions':
        this.conditionsScreen = false;
        this.descriptionScreen = true;
        break;
      case 'description':
        this.descriptionScreen = false;
        this.completeScreen = true;
        break;
      default:
        this.beginScreen = true;
        this.caretakerScreen = false;
        this.sectionsScreen = false;
        this.activitiesScreen = false;
        this.amenitiesScreen = false;
        this.terrainScreen = false;
        this.conditionsScreen = false;
        this.descriptionScreen = false;
        this.completeScreen = false;
        break;
    }

    this.modalWrapper.nativeElement.scrollTop = 0;
  }

  async navigateForward(currentSection: string) {
    switch (currentSection) {
      case 'start':
        this.beginScreen = false;
        if (this.boondock?.user?.id !== CARETAKER_TEDDY_ID) {
          this.caretakerScreen = false;
          this.sectionsScreen = true;
        } else {
          this.caretakerScreen = true;
        }
        break;
      case 'caretaker':
        this.caretakerScreen = false;
        this.sectionsScreen = true;
        break;
      case 'sections':
        this.sectionsScreen = false;
        this.reviewScreen = true;
        break;
      case 'review':
        this.reviewScreen = false;
        this.activitiesScreen = true;
        break;
      case 'activities':
        this.activitiesScreen = false;
        this.amenitiesScreen = true;
        break;
      case 'amenities':
        this.amenitiesScreen = false;
        this.terrainScreen = true;
        break;
      case 'terrain':
        this.terrainScreen = false;
        this.conditionsScreen = true;
        break;
      case 'conditions':
        this.conditionsScreen = false;
        this.descriptionScreen = true;
        break;
      case 'description':
        this.descriptionScreen = false;
        this.completeScreen = true;
        break;
      case 'complete':
        break;
      default:
        this.beginScreen = true;
        this.caretakerScreen = false;
        this.sectionsScreen = false;
        this.activitiesScreen = false;
        this.amenitiesScreen = false;
        this.terrainScreen = false;
        this.conditionsScreen = false;
        this.descriptionScreen = false;
        this.completeScreen = false;
        break;
    }

    this.modalWrapper.nativeElement.scrollTop = 0;
  }

  navigateBack(currentSection: string) {
    switch (currentSection) {
      case 'caretaker':
        this.beginScreen = true;
        this.caretakerScreen = false;
        break;
      case 'sections':
        this.caretakerScreen = true;
        this.sectionsScreen = false;
        break;
      case 'review':
        this.sectionsScreen = true;
        this.reviewScreen = false;
        break;
      case 'activities':
        this.reviewScreen = true;
        this.activitiesScreen = false;
        break;
      case 'amenities':
        this.activitiesScreen = true;
        this.amenitiesScreen = false;
        break;
      case 'terrain':
        this.amenitiesScreen = true;
        this.terrainScreen = false;
        break;
      case 'conditions':
        this.terrainScreen = true;
        this.conditionsScreen = false;
        break;
      case 'description':
        this.conditionsScreen = true;
        this.descriptionScreen = false;
        break;
      case 'complete':
        this.descriptionScreen = true;
        this.completeScreen = false;
        break;
      case 'start':
      default:
        this.beginScreen = true;
        this.caretakerScreen = false;
        this.sectionsScreen = false;
        this.activitiesScreen = false;
        this.amenitiesScreen = false;
        this.terrainScreen = false;
        this.conditionsScreen = false;
        this.descriptionScreen = false;
        this.reviewScreen = false;
        this.completeScreen = false;
        break;
    }

    this.modalWrapper.nativeElement.scrollTop = 0;
  }

  closeModal() {
    this.modalController.dismiss();
  }

  onCompleteReview() {
    this.beginScreen = false;
    this.caretakerScreen = false;
    this.sectionsScreen = false;
    this.activitiesScreen = false;
    this.amenitiesScreen = false;
    this.terrainScreen = false;
    this.conditionsScreen = false;
    this.descriptionScreen = false;
    this.reviewScreen = false;
    this.completeScreen = true;
  }
}
